<div class="grid-layout">
  <div class="auth-promo">
    <div class="promo-content">
      <p>
        Create your free profile to personalize your experience. Find the best
        EV stations, engage with the community, and much more!
      </p>
      <img src="assets/icons/signup.svg" alt="signup image" />

      <app-download-links></app-download-links>
    </div>
  </div>

  <div class="login-options">
    <div class="form-title-header">
      <h3 class="form-title">Reset Password</h3>
      <div class="title-underline"></div>
    </div>

    <div class="form-title-header">
      <div
        class="success-message"
        style="margin-bottom: 1rem"
        *ngIf="successMessage"
      >
        <mat-icon>check_circle</mat-icon>
        {{ successMessage }}
      </div>
      <div
        class="error-message"
        style="margin-bottom: 1rem"
        *ngIf="errorMessage"
      >
        <mat-icon>error</mat-icon>
        {{ errorMessage }}
      </div>
    </div>

    <form
      [formGroup]="form"
      class="auth-form"
      (ngSubmit)="onSubmit($event)"
      *ngIf="state === 'initial'"
    >
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" />
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        class="create-account-button full-width"
        [disabled]="isLoading()"
      >
        <mat-spinner *ngIf="isLoading()" diameter="20"></mat-spinner>
        <span *ngIf="!isLoading()">Send Code</span>
      </button>
    </form>

    <form
      [formGroup]="otpForm"
      class="auth-form"
      (ngSubmit)="onOtpSubmit($event)"
      *ngIf="state === 'verify'"
    >
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Code</mat-label>
        <input matInput formControlName="code" />
        <mat-error *ngIf="otpForm.controls['code'].hasError('required')"
          >Code is required</mat-error
        >
        <mat-error
          *ngIf="
            otpForm.controls['code'].hasError('minlength') ||
            otpForm.controls['code'].hasError('maxlength')
          "
          >Code must be 6 digits</mat-error
        >
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        class="create-account-button full-width"
        [disabled]="isLoading()"
      >
        <mat-spinner *ngIf="isLoading()" diameter="20"></mat-spinner>
        <span *ngIf="!isLoading()">Verify</span>
      </button>
      <button
        class="full-width"
        mat-button
        (click)="resendVerificationCode()"
        type="button"
        [disabled]="isResendButtonDisabled()"
      >
        Resend code
        {{ isResendButtonDisabled() ? "(" + formattedTime() + ")" : "" }}
      </button>
    </form>

    <form
      [formGroup]="resetForm"
      class="auth-form"
      (ngSubmit)="onResetSubmit($event)"
      *ngIf="state === 'reset'"
    >
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" />
        <mat-error *ngIf="resetForm.controls['password'].invalid">
          Password must be at least 6 characters long
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="password" formControlName="confirmPassword" />
        <mat-error *ngIf="resetForm.controls['confirmPassword'].invalid">
          Confirm Password must be same as Password
        </mat-error>
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        class="create-account-button full-width"
        [disabled]="isLoading()"
      >
        <mat-spinner *ngIf="isLoading()" diameter="20"></mat-spinner>
        <span *ngIf="!isLoading()">Reset</span>
      </button>
    </form>

    <div style="margin-top: 16px">
      <button mat-button class="toggle-button" (click)="openSignInForm()">
        Remember password? Sign in
      </button>
    </div>
  </div>
</div>
